import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import * as React from "react";

type CheckBoxListItem = {
  label?: string;
  value?: string | number;
};

export default function CheckBoxList({ ...props }) {
  const { id, name, list, selectedlist, title, handleClick } = props;
  const checkboxList = list as CheckBoxListItem[];

  const [checkedItems, setCheckedItems] = React.useState(selectedlist.length);
  const [expanded, setExpanded] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");

  const filteredList = checkboxList.filter((item: CheckBoxListItem) => {
    const query = searchText.trim().toLowerCase();

    if (!query) {
      return true;
    }

    return [item.label, item.value]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(query));
  });

  const handleChange = (event: any) => {
    if (event.target.checked) {
      setCheckedItems(checkedItems + 1);
    } else {
      setCheckedItems(checkedItems - 1);
    }
    handleClick && handleClick(event);
  };

  const handleExpand = (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  const handleSearchFocus = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    setExpanded(true);
  };

  const stopPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  const handleClearSearch = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    setSearchText("");
    setExpanded(true);
  };

  return (
    <>
      <Accordion
        expanded={expanded}
        onChange={handleExpand}
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          id="panel2-header"
          sx={{
            backgroundColor: "#ddd",
            fontSize: "0.875rem",
            minHeight: 40,
            "&.Mui-expanded": {
              minHeight: 40,
            },
            "& .MuiAccordionSummary-content": {
              margin: 0,
              "&.Mui-expanded": {
                margin: 0,
              },
            },
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              gap: 2,
              width: "100%",
              mb: "5px",
            }}
          >
            <Box component="span" sx={{ flexShrink: 0, width: "450px" }}>
              {title} {checkedItems ? `(${checkedItems} Selected)` : ""}
            </Box>
            <TextField
              id={`${id}-search`}
              // label="Search"
              size="small"
              value={searchText}
              variant="outlined"
              onChange={(event) => setSearchText(event.target.value)}
              onClick={handleSearchFocus}
              onFocus={handleSearchFocus}
              onKeyDown={stopPropagation}
              InputProps={{
                endAdornment: searchText ? (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Clear search"
                      edge="end"
                      onClick={handleClearSearch}
                      onFocus={stopPropagation}
                      size="small"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : undefined,
              }}
              sx={{
                // ml: "auto",
                ml: "0px",

                // minWidth: 220,
                width: "200px",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "transparent",
                  },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "transparent",
                  },
              }}
            />
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 280, overflowY: "auto" }}>
          <FormGroup>
            {filteredList.map((item: CheckBoxListItem, index: number) =>
              selectedlist.includes("" + item.value) ? (
                <FormControlLabel
                  key={index}
                  name={name}
                  sx={{ fontSize: "0.875rem" }}
                  control={<Checkbox checked />}
                  label={item.label}
                  value={item.value}
                  onChange={handleChange}
                />
              ) : (
                <FormControlLabel
                  key={index}
                  name={name}
                  sx={{ fontSize: "0.875rem" }}
                  control={<Checkbox />}
                  label={item.label}
                  value={item.value}
                  onChange={handleChange}
                />
              )
            )}
          </FormGroup>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
